var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleBarRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M223.335 260c-10.257 0-18.71-7.72-19.866-17.668l-.135-2.332V40c0-11.046 8.955-20 20-20 10.257 0 18.71 7.72 19.866 17.668l.135 2.332v200c0 11.046-8.955 20-20 20m-180.812-5.858c-7.21-7.21-7.764-18.554-1.663-26.4l1.663-1.884L128.374 140l-85.85-85.858c-7.21-7.21-7.765-18.554-1.664-26.4l1.663-1.884c7.21-7.21 18.555-7.764 26.4-1.664l1.885 1.664 99.999 100c7.21 7.21 7.764 18.554 1.663 26.4l-1.663 1.884-100 100c-7.81 7.81-20.473 7.81-28.284 0"
})));
export default SvgAngleBarRight;